export default "__VITE_ASSET__97789d96__"